import { connect } from "react-redux";

import _Modal from "./modal.jsx";
import _ModalHeader from "./modal_header.jsx";
import _ModalBody from "./modal_body.jsx";
import _ModalFooter from "./modal_footer.jsx";
import _ModalFooterSpinner from "./modal_footer_spinner.jsx";
import _ModalButton from "./modal_button.jsx";

export const Modal = _Modal;
export const ModalHeader = _ModalHeader;
export const ModalBody = _ModalBody;
export const ModalFooter = _ModalFooter;
export const ModalFooterSpinner = _ModalFooterSpinner;
export const ModalButton = _ModalButton;
